import { useIntl } from 'react-intl';
import { useNavigate } from 'react-router-dom';
import { TrendingUp } from 'lucide-react';
import { clsx } from 'clsx';

import { getCurrencySymbol } from '../lib';

import styles from './stats.module.css';

export function GoalStatCard({ card, goal, otherGoalsCount }) {
	const intl = useIntl();
	const navigate = useNavigate();

	const otherGoalsText =
		otherGoalsCount === 0
			? intl.formatMessage({ id: 'FinPathDashboardCartID26' })
			: intl.formatMessage(
					{ id: 'FinPathDashboardCartID25' },
					{ count: otherGoalsCount },
				);

	return (
		<div
			className={clsx(styles.card, styles.goal)}
			onClick={() => navigate(card.path)}
		>
			<div className={styles.title}>
				{intl.formatMessage({ id: card.titleId })}
			</div>
			<div className={styles.valueRow}>
				<span className={styles.amount}>
					{goal.savedAmount} /{goal.targetAmount}
					{getCurrencySymbol(goal.currency)}
				</span>
			</div>
			<div className={styles.bottomRow}>
				<span className={styles.goalNote}>{otherGoalsText}</span>
				<TrendingUp size={18} className={styles.trend} />
			</div>
		</div>
	);
}
